<template>
    <div class="card">
        <div class="card-header">
            <h4 class="card-title">
                {{$t("turnosDeOperarios")}}
            </h4>
            <p class="card-category">
                {{$t("relacionDeHorasTrabajadasYVentasRealizadasPorOperario")}}
            </p>
            <!--<div class="text-right">-->
            <!--<router-link :to="{name:'turnos-operarios', params:{idBusiness:idBusiness}}">-->
            <!--<span class="verTodos"><i class="fa fa-eye"></i> {{$t("verTodos")}}</span>-->
            <!--</router-link>-->
            <!--</div>-->
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="table-responsive" v-if="listTurnos.length > 0">
                        <table class="table table-bordered table-striped text-nowrap">
                            <thead class="thead-dark">
                            <tr>
                                <th>{{$t("nombre")}}</th>
                                <th>{{$t("horarioInicio")}}</th>
                                <th>{{$t("horaFin")}}</th>
                                <th>{{$t("horasTrabajadas")}}</th>
                                <th>{{$t("sueldo")}}</th>
                                <th>{{$t("ventas")}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="t in listTurnos">
                                <td>{{t.name}}</td>
                                <td>{{t.initDate | parseMinSec}}</td>
                                <td v-if="parseInt(t.endDate)===0" class="text-success"><strong>{{$t('enActivo')}}</strong></td>
                                <td v-else>{{t.endDate | parseDateMin}}</td>
                                <td>{{t.diffHora | timago}}</td>
                                <td align="right">{{t.import | currency}}</td>
                                <td align="right">{{t.amount | currency}}</td>
                            </tr>
                            </tbody>
                            <tfoot>
                            </tfoot>
                        </table>
                    </div>
                    <div v-else>
                        <div class="alert alert-danger">
                            {{$t("noHayTurnosDeOperarioParaMostrar")}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <hr>
            <div class="stats">
                <i class="fa fa-clock"></i> {{lastDate | timeago}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TurnosOperarios",

        props: ['onlineDetails', 'lastDate', 'idBusiness'],

        created() {

            this.turnosOperarios();
        },
        data() {
            return {

                listTurnos: [],
            }
        },

        methods: {

            turnosOperarios() {

                var tpvs = [];
                this.onlineDetails.forEach(function (x) {
                    if (x && x.online == 1) {
                        tpvs.push(x.idTpv);
                    }
                });


                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt,
                        listTpv: JSON.stringify(tpvs),
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios.get(this.$store.getters.apiUrl + "online/getTurnosOperariosActual", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.listTurnos = response.data.result;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }

        },
        watch: {
            onlineDetails: function (newOnlineDetails, oldOnlineDetails) {
                this.turnosOperarios();
            }
        },
    }
</script>

<style scoped>
    .card-category {
        color: #9a9a9a
    }

    .card-body {
        padding: 10px 15px;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Online/Widgets/TurnosOperarios.vue